import cn from 'classnames';
import type React from 'react';
import { useFormContext } from 'react-hook-form';
import { AddThin } from '@shared/assets/icons';
import { Card, IconButton } from '@shared/ui';
import * as st from './styles.module.scss';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const AddVideoMobile: React.FC<Props> = ({ ...props }) => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <Card className={st.card}>
      <div className={cn(st.card__inner, errors.promo_video && st.error)}>
        <div className={st.card__button}>
          <IconButton type="button" size={'small'} {...props}>
            <AddThin />
          </IconButton>
        </div>
      </div>
      {/*<span className={st.card__title}>Видео</span>*/}
    </Card>
  );
};
